import React, { forwardRef, useImperativeHandle } from 'react';
import Chip from '@mui/material/Chip';

const Step5 = forwardRef((props, ref) => {
  const [accesoServidorSenializacion, setAccesoServidorSenializacion] = React.useState(null);
  const [accesoServidorRetransmision, setAccesoServidorRetransmision] = React.useState(null);

  useImperativeHandle(ref, () => ({
    // Funciones visibles por otros componentes.
    getAccesoServidorSenializacion() {
      return accesoServidorSenializacion
    },
    getAccesoServidorRetransmision() {
      return accesoServidorRetransmision
    },
  }));

  const verificarServidorSenializacion = async () => {
    try {
      const response = await fetch('https://peerjs-server-hv.herokuapp.com/');
      if (response.ok) {
        setAccesoServidorSenializacion(true);
      } else {
        setAccesoServidorSenializacion(false);
      }
    } catch (err) {
      setAccesoServidorSenializacion(false);
    }
  };

  const verificarServidorRetransmision = async () => {
    try {
      const config = {
        iceServers: [
          {
            urls: 'turn:coturn.hospitalvirtual.com:3478',
            username: 'test',
            credential: 'test'
          },
        ],
      };
      const peerConnection = new RTCPeerConnection(config);
      peerConnection.onicecandidate = (event) => {
        if (event.candidate) {
          const candidate = event.candidate;
          if (candidate.type === 'relay') {
            setAccesoServidorRetransmision(true);
            peerConnection.close();
          }
        } else {
          setAccesoServidorRetransmision(false);
        }
      };

      peerConnection.createDataChannel('test');
      try {
        const offer = await peerConnection.createOffer();
        await peerConnection.setLocalDescription(offer);
      } catch (err) {
        setAccesoServidorRetransmision(false);
      }
    } catch (err) {
      setAccesoServidorRetransmision(false);
    }
  };

  const init = () => {
    verificarServidorSenializacion();
    verificarServidorRetransmision();
  }

  React.useEffect(() => {
    init();
  }, []);

  return (
    <div style={{ minHeight: "70vh" }}>
      <h2>Verificación de red</h2>
      <div style={{ marginBottom: "20px", padding: "10px", borderTop: "1px solid lightGray", borderBottom: "1px solid lightGray" }}>
        <div style={{ textAlign: "left", fontSize: "18px", marginBottom: "5px" }}>Señalización:</div>
        {accesoServidorSenializacion != null ? accesoServidorSenializacion ? <Chip label="Ok, perfecto." color="success" />: <Chip label="No se pudo acceder" color="error" /> : <Chip label="?" color="warning" />}
      </div>
      <div style={{ marginBottom: "20px", padding: "10px", borderTop: "1px solid lightGray", borderBottom: "1px solid lightGray" }}>
        <div style={{ textAlign: "left", fontSize: "18px", marginBottom: "5px" }}>Retransmisión:</div>
        {accesoServidorRetransmision != null ? accesoServidorRetransmision ? <Chip label="Ok, perfecto." color="success" />: <Chip label="No se pudo acceder" color="error" /> : <Chip label="?" color="warning" />}
      </div>
    </div>
  );
});

export default Step5;